import React from "react";

export default class TSFormUtils {
  public static renderControl_3_9(label: string, control: any) {
    return (
      <div className="form-group row">
        <label className="form-label col-form-label hidden-xs hidden-sm col-md-3">
          {label}
        </label>
        <div className="col-12 col-sm-12 col-md-9">{control}</div>
      </div>
    );
  }
}
